export const COMPONENTS_DEFAULT_SKELETON_HEIGHT = "46px";
